import { useMemo } from 'react';
import { ShieldAlert } from 'lucide-react';

// Full-screen diagonal watermark + confidentiality banner for the staff portal.
// Makes any screenshot traceable to the logged-in user without blocking reading.
export const ConfidentialWatermark = ({ user }) => {
  const stamp = useMemo(() => {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }, []);

  if (!user) return null;
  const line = `${user.name || ''} · ${user.email || ''} · ${stamp}`;

  const rows = [];
  for (let i = 0; i < 14; i++) {
    rows.push(
      <div
        key={i}
        className="whitespace-nowrap font-mono select-none"
        style={{
          fontSize: '13px',
          letterSpacing: '2px',
          color: 'currentColor',
          opacity: 1,
          marginLeft: i % 2 === 0 ? '0' : '-140px',
        }}
      >
        {`${line}     `.repeat(6)}
      </div>
    );
  }

  return (
    <>
      {/* Watermark layer */}
      <div
        aria-hidden="true"
        data-testid="confidential-watermark"
        className="fixed inset-0 z-[90] pointer-events-none overflow-hidden text-foreground"
        style={{ opacity: 0.045 }}
      >
        <div
          className="flex flex-col justify-between"
          style={{
            transform: 'rotate(-24deg) scale(1.5)',
            transformOrigin: 'center',
            height: '160vh',
            marginTop: '-30vh',
            gap: '9vh',
          }}
        >
          {rows}
        </div>
      </div>

      {/* Confidentiality banner */}
      <div
        data-testid="confidential-banner"
        className="fixed bottom-0 left-0 right-0 z-[95] pointer-events-none flex justify-center pb-1.5"
      >
        <div className="flex items-center gap-1.5 bg-background/85 backdrop-blur-sm border border-border rounded-sm px-3 py-1">
          <ShieldAlert className="w-3 h-3 text-yellow-500" strokeWidth={1.5} />
          <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
            Confidential — do not share or distribute
          </span>
        </div>
      </div>
    </>
  );
};

export default ConfidentialWatermark;
